<template>
  <div class="flex flex-col items-center justify-center mt-10">
    <!--Image Select Modal -->
    <keep-alive>
      <step-image-modal
        v-if="showStepModal"
        @close="showStepModal = false"
        :accentColor="survey.accentColor"
        :step="step"
      ></step-image-modal>
    </keep-alive>

          <div class="mx-auto font-bold text-center w-full">
            <click-to-edit
              v-model="title"
              pClass="text-xl block mx-auto px-5 border border-transparent border-solid hover:border-blue-200 cursor-pointer rounded text-center"
              inputClass="text-xl block mx-auto px-5 cursor-pointer rounded text-center"
              
              :pStyle="{ color: survey.fontColor, 'font-family': survey.fontFamily, 'width': 'fit-content', 'min-height': '1.8rem' }"
              :inputStyle="{ 'font-family': survey.fontFamily,  'min-height': '1.8rem'  }"
            ></click-to-edit>

          </div>
          <div class="mx-auto text-center mt-1 w-full">

            <click-to-edit
              v-model="subtitle"
              pClass="block mx-auto px-5 border border-transparent border-solid hover:border-blue-200 cursor-pointer rounded text-center"
              inputClass="block mx-auto px-5 cursor-pointer rounded text-center"
              
              :pStyle="{ color: survey.fontColor, 'font-family': survey.fontFamily, 'width': 'fit-content',  'min-height': '1.5rem'  }"
              :inputStyle="{ 'font-family': survey.fontFamily,  'min-height': '1.5rem'  }"
            ></click-to-edit>
          </div>

    <div class="my-10">
      <div v-if="step.image !== null">
        <div
          
          class="flex flex-row justify-center"
        >
          <div class="w-12"></div>

          <div
            class="display-block mx-auto cursor-pointer rounded"
            v-on:click="showModal"
          >
            <img v-if="step.image == 'link'" :src="step.image_link" />
            <svg-inline
              v-else
              class=" h-28 "
              style="width: fit-content"
              :style="{ color: survey.accentColor }"
              :image="step.image"
              v-tooltip="'Change image'"
            />
          </div>

          <div class="w-12 flex flex-row-reverse">
            <div v-if="step.image !== null" @click="removeImage">
              <svg-icon
                icon="heroicons/outline/x"
                class="h-6 w-6 cursor-pointer p-1 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full"
                v-tooltip="'Remove image'"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-else v-on:click="showModal">
        <div class="block">
          <svg-icon
            icon="heroicons/solid/plus-circle"
            class="mt-2 w-10 h-10 p-0 text-purple-400 hover:text-purple-700 cursor-pointer"
            v-tooltip="'Add an image'"
          />
        </div>
      </div>
    </div>

    <SurveyButton :survey="survey" :step="step" @click="$emit('next-step')" :text="button.welcome_text" />
  </div>
</template>

<script>
import Step from "@/models/Step";
import ClickToEdit from "@/components/ClickToEdit.vue";
import SurveyButton from "@/components/Survey/SurveyButton.vue";

export default {
  props: ["survey", "step"],
  data() {
    return {
      showStepModal: false,
    };
  },
  components: {
    ClickToEdit,
    SurveyButton,
    StepImageModal: () =>
      import(
        /* webpackPrefetch: true */ "@/components/Builder/StepImageModal.vue"
      ),
  },
  computed: {
    button(){
      return this.survey.buttons[0];
    },
    title: {
      get() {
        return this.step.title;
      },
      set(value) {
        if (value !== this.step.title) {
          Step.update({
            where: this.step.id,
            data: {
              title: value,
            },
          });
        }
      },
    },
    subtitle: {
      get() {
        return this.step.subtitle;
      },
      set(value) {
        if (value !== this.step.subtitle) {
          Step.update({
            where: this.step.id,
            data: {
              subtitle: value,
            },
          });
        }
      },
    },
  },
  methods: {
    removeImage() {
      Step.update({
        where: this.step.id,
        data: {
          image: null,
        },
      });
    },
    showModal(){
      this.showStepModal = true;
    },
    debounceClick: function(func) {
      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        func();
      }, 200); // delay
    },
  },
};
</script>

<style></style>
